import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { Partner } from '../../models/stack9/Partner';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

type BaseRequirementDrawerProps = {
  open: boolean;
  onClose: () => void;
  id?: number;
  initialValues?: Partial<Partner>;
};

export const BaseRequirementDrawer = ({
  open,
  onClose,
  id,
  initialValues = {},
}: BaseRequirementDrawerProps) => {
  const formFields = [
    { field: 'question_type', colSize: 12 },
    { field: 'sequence', colSize: 12 },
    { field: 'requirement_section_id' },
    { field: 'question' },
    { field: 'required_document_types' },
    { field: 'allow_text_area', colSize: 8 },
    { field: 'is_mandatory', colSize: 8 },
    { field: 'preserve_for_renewal', colSize: 8 },
    { field: 'is_active' },
  ];

  return (
    <EntityDrawer
      title="base requirement"
      open={open}
      id={id}
      formFields={formFields}
      initialValues={initialValues}
      onClose={onClose}
      screenQueryName={EDetailsQueryNames.GetBaseRequirementDetails}
      entityName={entityNames.BASE_REQUIREMENT}
      editRoute={AppRoutes.BaseRequirementDetail}
      relativePath={AppRoutes.BaseRequirementList}
    />
  );
};
